export default {
  error: '',
  errorAdditional: '',
  alert: ''
}
